import { ReactNode, useState } from "react";

import {
  Dialog as PaperDialog,
  Portal,
  useTheme,
  Text,
  Button,
} from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  title: string;
  message: string;
  confirmButton: {
    text: string;
    color?: string;
    onPress: () => Promise<void>;
  };
  renderTrigger: (props: Record<"open" | "close", () => void>) => ReactNode;
};

export function Dialog({
  title,
  message,
  confirmButton,
  renderTrigger,
}: Props) {
  const [visible, setVisible] = useState(false);
  const tailwind = useTailwind();
  const { colors } = useTheme();

  const open = () => setVisible(true);
  const close = () => setVisible(false);

  async function onConfirmPress() {
    await confirmButton.onPress();
    close();
  }

  return (
    <>
      {renderTrigger({ open, close })}

      <Portal>
        <PaperDialog
          style={[
            tailwind("rounded-xl relative"),
            { backgroundColor: colors.surface },
          ]}
          visible={visible}
          onDismiss={close}
        >
          <PaperDialog.Title>{title}</PaperDialog.Title>
          <PaperDialog.Content>
            <Text>{message}</Text>
          </PaperDialog.Content>
          <PaperDialog.Actions>
            <Button onPress={close}>Cancelar</Button>
            <Button onPress={onConfirmPress} textColor={confirmButton.color}>
              {confirmButton.text}
            </Button>
          </PaperDialog.Actions>
        </PaperDialog>
      </Portal>
    </>
  );
}
